import { Injectable } from '@angular/core';
// import { ToastyService, ToastyConfig } from "ngx-toasty";



export enum TYPE {
  DEFAULT = '',
  INFO = 'bg-info',
  SUCCESS = 'bg-success',
  WAIT = 'bg-primary',
  ERROR = 'bg-danger',
  WARNING = 'bg-warning'
}
export enum POSITION {
   BOTTOM_RIGHT = 'bottom-0 end-0',
   BOTTOM_LEFT = 'bottom-0 start-0',
   TOP_RIGHT = 'top-0 end-0',
   TOP_LEFT =  'top-0 start-0', 
   TOP_CENTER =  'top-0 start-50 translate-middle-x',
   BOTTOM_CENTER = "bottom-0 start-50 translate-middle-x",
   CENTER_CENTER = "top-50 start-50 translate-middle"
}

export interface Notification {
	timeout?: number;
  title?: string;
  msg?: string;
  onClick?: Function;
  onClickClose?: boolean;
  type?: TYPE
  position?: POSITION,
  autohide?: boolean

};
@Injectable({
  providedIn: 'root'
})
export class NotifyService {
  notifications: Notification[] = [];
  get POSITION() { 
    return  POSITION 
  };
  position: POSITION;
  constructor (
    // private ts: ToastyService,
    // private tc: ToastyConfig
  
  ) {
    // this.tc.theme = "bootstrap";
    this.resetPosition ();
  }
  default = this.notify.bind (this, TYPE.DEFAULT);
  info = this.notify.bind (this, TYPE.INFO);
  wait = this.notify.bind (this, TYPE.WAIT);
  warning = this.notify.bind (this, TYPE.WARNING);
  error = this.notify.bind (this, TYPE.ERROR);
  success = this.notify.bind (this, TYPE.SUCCESS);

  private notify (type: TYPE, o, pos = POSITION.BOTTOM_RIGHT) {
    this.resetPosition();
    this.position = pos;

    if(!o.msg && o.title) {
      o.msg = o.title;
      delete o.title;
    }
    o.type = type;
    o.position = pos;
    o.onClick = o.onClick || (() => {});
    // return this.ts [type] (o);
    this.notifications.push(o);

  }
  getPosition () {
    return this.position;
  }
  resetPosition () {
    this.position = POSITION.BOTTOM_RIGHT;
  } 
  remove(toast: Notification) {
		this.notifications = this.notifications.filter((t) => t !== toast);
	}

	clear() {
		this.notifications.splice(0, this.notifications.length);
	}
    timeout(type = 'sm') {
        switch(type) {
            case 'sm':
                return 5000;
            case 'lg':
                return 30000;
            case 'xl':
                return 60000;
            case 'xxl':
                return 300000;
            case 'md':
                return 10000;
        }
    }
}
